import { getAvailableLendersByLenderCommissions } from '__core/shared/util/salestrekker';
/* @ngInject */

export default (
  $rootScope,
  $scope,
  $state,
  $stateParams,
  $timeout,
  $mdDialog,
  $mdUtil,
  $q,
  $window,
  Upload,
  cookies,
  webpage,
  authenticationService,
  eventService,
  dateTimeService,
  jsonFactory,
  helperService,
  helperPdfService,
  accountService,
  Contact,
  contactService,
  contactsService,
  Document,
  LabelType,
  ticketService,
  ticketsService,
  workflowService,
  labelsService,
  AssetFinance,
  assetFinanceService,
  lendersService,
  assetFinanceAssetToBeFinancedPdfService,
  assetFinanceFinanceProposalPdfService,
  aboutUsDetailsPdfService,
  quickToolService,
  uiService,
  TICKET,
  INSTANCE
) => {
  $scope.Model = {
    hasBrokerToolsEnabled: $rootScope.hasBrokerToolsEnabled(),
    countries: [],
    organizationCountry: helperService.getOrganizationCountry(),
    currentTicket: {},
    currentWorkflow: {},
    currentTicketOwner: {},
    currentTicketAssetFinance: {},
    availableContacts: [],
    availablePersonOnlyContacts: [],
    availableCompanyOnlyContacts: [],
    availableLabels: [],
    availableLenders: [],
    availableLendersDocuments: [],
    availableLiabilityTypes: [],
    availableInsuranceTypes: [],
    availableOtherAdviserTypes: [],
    activeSection: 'assetDetails',
    availableSections: ['assetDetails', 'financeProposal'],
    isSidebarMinimized:
      cookies.get('stSidebar') && cookies.get('stSidebar') !== undefined
        ? cookies.get('stSidebar')
        : false,
    isReady: false,
    availableAssetFinanceInsuranceTypes:
      assetFinanceService.getAvailableAssetFinanceInsuranceTypes(),
    pdfTypes: helperService.getAvailablePdfTypes(),
    isSavePdfPreparing: false,
    isViewPdfPreparing: false,
    isSearchStarted: false,
    isSearchReset: false
  };

  /*
   * Set webpage Title
   * --------------------------------------------------------------------------------
   */
  webpage.pageTitle('Loading, please wait');

  /*
   * Methods
   * --------------------------------------------------------------------------------
   */
  const loadLabels = () => {
    labelsService
      .getAvailable({
        orderBy: 'name',
        coerceTo: 'string',
        isDescending: false,
        isActive: true
      })
      .then((labels) => {
        $scope.Model.availableLabels = labels;
        $scope.Model.availableFileLabels = labels.filter(
          (l) => l.type.name === LabelType.file.name && l.isLocked
        );
        $scope.Model.availableContactLabels = labels.filter(
          (l) => l.type.name === LabelType.contact.name
        );
      });
  };

  const loadCountries = () => {
    const deferred = $q.defer();
    jsonFactory.getCountries().then((data) => {
      $scope.Model.countries = data;
      deferred.resolve(data);
    });
    return deferred.promise;
  };

  const loadWorkflow = () => {
    workflowService.readWorkflow({ id: $stateParams.id }).then((workflow) => {
      $scope.Model.currentWorkflow = workflow;
    });
  };

  const loadTicket = (idTicket) => {
    const deferred = $q.defer();
    ticketService.readTicket({ id: idTicket }).then((ticket) => {
      $scope.Model.currentTicket = ticket;
      deferred.resolve(ticket);
    });
    return deferred.promise;
  };

  const loadAccount = (idOwner) => {
    const deferred = $q.defer();
    accountService.readAccount({ id: idOwner }).then((account) => {
      $scope.Model.currentTicketOwner = account;
      deferred.resolve(account);
    });
    return deferred.promise;
  };

  const loadContacts = (idContacts) => {
    const deferred = $q.defer();
    contactsService.getSpecific({ idContacts, isActive: true }).then((contacts) => {
      $scope.Model.availableContacts = _.compact($scope.sortByIdContacts(contacts));
      if ($scope.Model.availableContacts.length) {
        $scope.Model.availablePersonOnlyContacts = $scope.Model.availableContacts.filter(
          (c) => !c.isCompany
        );
        $scope.Model.availableCompanyOnlyContacts = $scope.Model.availableContacts.filter(
          (c) => c.isCompany
        );
      }
      deferred.resolve(contacts);
    });
    return deferred.promise;
  };

  const loadLendersDocuments = (idLenders) => {
    lendersService
      .getDocuments({ idLenders, types: ['LOGO', 'CALCULATOR'] })
      .then((lendersDocuments) => {
        if (lendersDocuments && lendersDocuments.length) {
          $scope.Model.availableLendersDocuments = lendersDocuments;
        }
      });
  };

  const loadLenders = (currentTicketOwner) => {
    const deferred = $q.defer();
    lendersService
      .getAvailable({
        cca2: [$scope.Model.organizationCountry.cca2],
        type: 'ASSET_FINANCE'
      })
      .then((lenders) => {
        if (lenders?.length) {
          $scope.Model.availableLenders = getAvailableLendersByLenderCommissions(
            lenders,
            $rootScope.CurrentOrganization,
            currentTicketOwner,
            $scope.Model.currentWorkflow,
            $rootScope.IsEnterprise,
            $scope.Model.currentAssetFinance?.isCommercial || false
          );
          if ($scope.Model.availableLenders?.length) {
            $scope.Model.filteredLenders = $scope.Model.availableLenders;
            const idLenders = _.compact(_.uniq(_.map($scope.Model.availableLenders, 'id')));
            loadLendersDocuments(idLenders);
          }
        }
        deferred.resolve(lenders);
      });
    return deferred.promise;
  };

  const loadAssetFinance = (idAssetFinance) => {
    const deferred = $q.defer();
    assetFinanceService.readAssetFinance({ id: idAssetFinance }).then((assetFinance) => {
      $scope.Model.currentAssetFinance = assetFinance;
      deferred.resolve(assetFinance);
    });
    return deferred.promise;
  };

  const initialize = () => {
    loadLabels();
    loadWorkflow();
    loadCountries().then(() => {
      loadTicket($stateParams.dd).then(() => {
        webpage.pageTitle($scope.Model.currentTicket.getName());
        if ($scope.Model.currentTicket.idAssetFinance) {
          loadContacts($scope.Model.currentTicket.idClients).then(() => {
            loadAssetFinance($scope.Model.currentTicket.idAssetFinance).then(() => {
              $scope.Model.currentAssetFinance.quickQuoteFinanceProposal.isEdit = true;
              loadAccount($scope.Model.currentTicket.idOwner).then(() => {
                loadLenders($scope.Model.currentTicketOwner).then(() => {
                  if ($scope.hasAssetFinanceTools()) {
                    dateTimeService.getSet(
                      $scope,
                      $scope.Model.currentAssetFinance,
                      'quickQuoteSettlementDate',
                      'getSetSettlementDate'
                    );
                    $scope.Model.isReady = true;
                    eventService.intercomHide();
                  } else {
                    $state.transitionTo('factFind', {
                      id: $stateParams.id,
                      dd: $stateParams.dd
                    });
                  }
                });
              });
            });
          });
        } else {
          $state.transitionTo('factFind', {
            id: $stateParams.id,
            dd: $stateParams.dd
          });
        }
      });
    });
  };

  initialize();

  /*
   * Asset finance quick quote ~ Switch UI Section
   * --------------------------------------------------------------------------------
   */
  $scope.showSection = (section) => {
    $scope.Model.activeSection = section;
  };

  $scope.getNumberOfSection = (section) => {
    const idx = $scope.Model.availableSections.indexOf(section);
    return idx + 1;
  };

  /*
   * Asset finance quick quote ~ Helpers
   * --------------------------------------------------------------------------------
   */
  $scope.isDealOwnerBroker = () =>
    authenticationService.isBroker($scope.Model.currentTicket.idOwner);

  $scope.hasAssetFinanceTools = () =>
    $scope.isDealOwnerBroker() &&
    $rootScope.hasBrokerToolsEnabled() &&
    $scope.Model.filteredLenders.length &&
    $scope.Model.currentWorkflow.isAssetFinance() &&
    $rootScope.canSeeAssetFinanceTools();

  $scope.showAssetFinanceTools = () =>
    $scope.Model.isReady &&
    $scope.isDealOwnerBroker() &&
    $scope.Model.hasBrokerToolsEnabled &&
    $scope.Model.filteredLenders.length &&
    $scope.Model.currentWorkflow.isAssetFinance();

  $scope.sortByIdContacts = (contacts) => {
    const sortedContacts = [];
    $scope.Model.currentTicket.idClients.forEach((id) => {
      const contact = contacts.find((c) => c.id === id);
      sortedContacts.push(contact);
    });
    return sortedContacts;
  };

  $scope.setCaretClass = (isView) =>
    `${ticketService.setCaretClass(isView)} ${
      $scope.Model.isSidebarMinimized || !$rootScope.IsMedia('gt-sm') ? 'hide' : ''
    }`;

  $scope.toggleSidebar = () => {
    $scope.Model.isSidebarMinimized = !$scope.Model.isSidebarMinimized;
    if ($scope.Model.isSidebarMinimized) {
      cookies.set('stSidebar', btoa('sidebar is minimized'), {
        path: '/'
      });
    } else {
      cookies.remove('stSidebar', { path: '/' });
    }
  };

  $scope.getLabel = (idLabel) => $scope.Model.availableFileLabels.find((l) => l.id === idLabel);

  $scope.getContact = (idContact) =>
    $scope.Model.availableContacts.find((c) => c.id === idContact);

  $scope.getClientNames = () => {
    const names = [];
    _.forEach($scope.Model.availableContacts, (c) => names.push(c.getName()));
    return names.join(', ');
  };

  $scope.toggleStartingSearch = (isSearchStarted) => {
    $scope.Model.isSearchStarted = isSearchStarted;
  };

  $scope.resetListOfSearchProducts = () => {
    $scope.Model.isSearchReset = false;
    $timeout(() => {
      $scope.Model.isSearchReset = true;
    });
  };

  $scope.createApplicationFormPdf = ($event, isView) => {
    $event.stopPropagation();
    if (isView) {
      $scope.Model.isViewPdfPreparing = true;
    } else {
      $scope.Model.isSavePdfPreparing = true;
    }
    const now = moment.utc().tz($rootScope.CurrentTimeZone()).format('X');
    const date = dateTimeService.getFormattedDate(now);
    const preparedFor = $scope.getClientNames();
    const orgLogo = $rootScope?.CurrentOrganization?.organization?.logo
      ? $rootScope.CurrentOrganization.organization.logo.replace(
          /([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/gi,
          $rootScope.CurrentOrganization.id
        )
      : INSTANCE.url + INSTANCE.logo;
    quickToolService.getBase64FromImageUrl({ url: orgLogo }).then((res) => {
      const docDefinition = {
        pageSize: 'A4',
        pageMargins: [40, 40, 40, 40],
        content: [
          {
            table: {
              widths: ['*'],
              headerRows: 1,
              body: [
                [
                  {
                    width: 180,
                    height: 30,
                    image: res.data,
                    margin: [5, 3, 0, 3],
                    style: 'tableHeader'
                  }
                ]
              ]
            },
            layout: 'noBorders'
          },
          {
            text: '',
            margin: [0, 10, 0, 0]
          },
          helperPdfService.createHeader({
            title: 'FINANCE QUOTE'
          }),
          {
            table: {
              widths: ['25%', '25%', '25%', '25%'],
              body: [
                [
                  {
                    text: [
                      { text: 'Prepared by\n', style: 'label' },
                      {
                        text: $rootScope.CurrentAccount.getName(),
                        style: 'value'
                      }
                    ]
                  },
                  {
                    text: [
                      { text: 'Prepared for\n', style: 'label' },
                      {
                        text: preparedFor || '-',
                        style: 'value'
                      }
                    ],
                    colSpan: 2
                  },
                  '',
                  {
                    text: [
                      { text: 'Prepared on\n', style: 'label' },
                      {
                        text: date,
                        style: 'value'
                      }
                    ]
                  }
                ]
              ]
            },
            layout: 'noBorders'
          },
          aboutUsDetailsPdfService.prepareAboutUsDetails({
            ticketOwner: $scope.Model.currentTicketOwner || {},
            showCreditLicenceDetails: false
          }),
          assetFinanceAssetToBeFinancedPdfService.prepareAssetFinanceAssetToBeFinancedDetails({
            assetDetails: $scope.Model?.currentAssetFinance?.quickQuoteAssetDetails || [],
            additionalProduct: null,
            isQuickTool: true
          }),
          assetFinanceFinanceProposalPdfService.prepareAssetFinanceFinanceProposalDetails({
            financeProposal: $scope.Model?.currentAssetFinance?.quickQuoteFinanceProposal,
            date: $scope.Model?.currentTicket?.values?.onceOffDueDate,
            isCommercial: $scope.Model.currentAssetFinance?.isCommercial || false
          }),
          {
            text: '',
            margin: [0, 20, 0, 0]
          },
          helperPdfService.createHeader({
            title: 'DISCLAIMER'
          }),
          {
            text: 'This quote is subject to review in 7 days and does not constitute an offer of finance.\nFinance approval is subject to formal credit assessment.',
            style: ['value', 'marginTop']
          }
        ],
        styles: {
          header: {
            fontSize: 16,
            bold: true,
            margin: [0, 0, 0, 0]
          },
          subHeader: {
            fontSize: 11,
            margin: [0, 0, 0, 0]
          },
          subSubHeader: {
            fontSize: 10,
            margin: [0, 2, 0, 0]
          },
          prepared: {
            fontSize: 10,
            alignment: 'right',
            margin: [0, 6, 5, 0]
          },
          marginTop: {
            margin: [0, 7, 0, 0]
          },
          marginBottom: {
            margin: [0, 0, 7, 0]
          },
          tableFontSize: {
            fontSize: 10
          },
          tableHeader: {
            fillColor: '#eee'
          },
          tableMarginTop: {
            margin: [0, 10, 0, 0]
          },
          tableCellMarginTop: {
            margin: [0, 2, 0, 0]
          },
          tableCellMarginLeftTopBottom: {
            margin: [4, 2, 0, 2]
          },
          tableCellMarginRightTopBottom: {
            margin: [0, 2, 4, 2]
          },
          tableCellMarginTopBottom: {
            margin: [0, 2, 0, 2]
          },
          tableCellLeftAlign: {
            alignment: 'left'
          },
          tableCellRightAlign: {
            alignment: 'right'
          },
          tableCellCenterAlign: {
            alignment: 'center'
          },
          label: { fontSize: 8, color: '#777' },
          value: { fontSize: 10 },
          valueXS: { fontSize: 8 },
          valueXL: { fontSize: 12 },
          lists: { fontSize: 10 },
          noColor: { color: '#fff' }
        }
      };
      pdfMake.tableLayouts = {
        defaultLayout: {
          hLineWidth(i, node) {
            return i === node.table.headerRows ? 1 : 0.5;
          },
          vLineWidth() {
            return 0.5;
          },
          hLineColor(i, node) {
            return i === 0 || i === node.table.body.length ? '#333' : '#aaa';
          },
          vLineColor(i, node) {
            return i === 0 || i === node.table.widths.length ? '#333' : '#aaa';
          },
          paddingLeft() {
            return 0;
          },
          paddingRight() {
            return 0;
          },
          paddingTop() {
            return 0;
          },
          paddingBottom() {
            return 0;
          }
        },
        header: {
          hLineWidth(i, node) {
            return i === node.table.headerRows ? 0 : 2;
          },
          vLineWidth() {
            return 0;
          },
          hLineColor(i, node) {
            return i === node.table.body.length ? '#000' : '#fff';
          },
          paddingLeft() {
            return 0;
          },
          paddingRight() {
            return 0;
          },
          paddingTop() {
            return 0;
          },
          paddingBottom() {
            return 0;
          }
        },
        subHeader: {
          hLineWidth(i, node) {
            return i === node.table.headerRows ? 0 : 0.5;
          },
          vLineWidth() {
            return 0;
          },
          hLineColor(i, node) {
            return i === node.table.body.length ? '#999' : '#fff';
          },
          paddingLeft() {
            return 0;
          },
          paddingRight() {
            return 0;
          },
          paddingTop() {
            return 2;
          },
          paddingBottom() {
            return 2;
          }
        },
        noBorders: {
          hLineWidth() {
            return 0;
          },
          vLineWidth() {
            return 0;
          },
          hLineColor() {
            return 0;
          },
          paddingLeft() {
            return 5;
          },
          paddingRight() {
            return 5;
          },
          paddingTop() {
            return 3;
          },
          paddingBottom() {
            return 3;
          }
        },
        noBordersNoPadding: {
          hLineWidth() {
            return 0;
          },
          vLineWidth() {
            return 0;
          },
          hLineColor() {
            return 0;
          },
          paddingLeft() {
            return 0;
          },
          paddingRight() {
            return 0;
          },
          paddingTop() {
            return 0;
          },
          paddingBottom() {
            return 0;
          }
        }
      };
      const fileName = `${moment.utc().year()}${moment.utc().month() + 1}${moment
        .utc()
        .date()} Finance quote.pdf`;
      if (isView) {
        helperPdfService.viewOrSavePdf({ docDefinition, isView: true }).then((view) => {
          $scope.Model.isViewPdfPreparing = !view.status;
        });
      } else {
        helperPdfService
          .viewOrSavePdf({
            ticket: $scope.Model.currentTicket,
            docDefinition,
            fileName,
            isView: false
          })
          .then((save) => {
            $scope.Model.isSavePdfPreparing = !save.status;
          });
      }
    });
  };

  /*
   * Asset finance quick quote - Details
   * --------------------------------------------------------------------------------
   */
  $scope.saveQuickQuoteAssetDetails = (data) => {
    if (!_.isEmpty(data) && data?.quickQuoteAssetDetails !== undefined) {
      $scope.Model.currentAssetFinance.quickQuoteAssetDetails = data.quickQuoteAssetDetails;
    }
    if (!_.isEmpty(data?.quickQuoteFinanceProposal)) {
      $scope.Model.currentAssetFinance.quickQuoteFinanceProposal =
        data.quickQuoteFinanceProposal;
    }
    if (!_.isEmpty(data) && data?.isQuickQuoteUnsecured !== undefined) {
      $scope.Model.currentAssetFinance.isQuickQuoteUnsecured = data.isQuickQuoteUnsecured;
    }
    if (!_.isEmpty(data)) {
      $scope.saveAssetFinance({
        quickQuoteAssetDetails: $scope.Model.currentAssetFinance.quickQuoteAssetDetails || [],
        quickQuoteFinanceProposal:
          $scope.Model.currentAssetFinance.quickQuoteFinanceProposal || {},
        isQuickQuoteUnsecured: $scope.Model.currentAssetFinance.isQuickQuoteUnsecured || false,
        aFCD: data?.aFCD || ''
      });
    }
  };

  /*
   * Asset finance quick quote ~ Finance proposal
   * --------------------------------------------------------------------------------
   */
  $scope.saveQuickQuoteFinanceProposal = (data) => {
    if (!_.isEmpty(data?.quickQuoteFinanceProposal)) {
      $scope.Model.currentAssetFinance.quickQuoteFinanceProposal =
        data.quickQuoteFinanceProposal;
    }
    if (!_.isEmpty(data?.quickQuoteSearchFields)) {
      $scope.Model.currentAssetFinance.quickQuoteSearchFields = data.quickQuoteSearchFields;
    }
    if (!_.isEmpty(data)) {
      $scope.saveAssetFinance({
        quickQuoteFinanceProposal: $scope.Model.currentAssetFinance.quickQuoteFinanceProposal,
        quickQuoteSearchFields: $scope.Model.currentAssetFinance.quickQuoteSearchFields,
        aFCD: data?.aFCD || ''
      });
    }
  };

  /*
   * Asset finance quick quote ~ Lender and product
   * --------------------------------------------------------------------------------
   */
  $scope.saveQuickQuoteLenderAndProduct = (data) => {
    if (!_.isEmpty(data?.quickQuoteFinanceProposal)) {
      $scope.Model.currentAssetFinance.quickQuoteFinanceProposal =
        data.quickQuoteFinanceProposal;
    }
    if (!_.isEmpty(data) && data?.quickQuoteSelectedProduct !== undefined) {
      $scope.Model.currentAssetFinance.quickQuoteSelectedProduct =
        data.quickQuoteSelectedProduct;
    }
    if (!_.isEmpty(data)) {
      $scope.saveAssetFinance({
        quickQuoteFinanceProposal: $scope.Model.currentAssetFinance.quickQuoteFinanceProposal,
        quickQuoteSelectedProduct: $scope.Model.currentAssetFinance.quickQuoteSelectedProduct,
        aFCD: data?.aFCD || ''
      });
    }
  };

  /*
   * Asset finance ~ Back
   * --------------------------------------------------------------------------------
   */
  $scope.back = () => {
    $state.transitionTo('deal', { id: $stateParams.id, dd: $stateParams.dd });
  };

  /*
   * Asset finance ~ Save Asset finance
   * --------------------------------------------------------------------------------
   */
  $scope.saveAssetFinance = (data) => {
    const assetFinance = data;
    const aFCD = data?.aFCD || '';
    if (data?.aFCD !== undefined) {
      delete assetFinance.aFCD;
    }
    if (!$scope.Model.currentTicket.isSettled) {
      $scope.Model.currentAssetFinance.deleteDateObject();
      assetFinance.id = $scope.Model.currentAssetFinance.id;
      if (assetFinance.id !== '') {
        assetFinanceService.updateAssetFinancePartial(assetFinance).then((result) => {
          if (result.status) {
            uiService.toast({
              text: {
                p1: 'Asset finance for deal',
                p2: $scope.Model.currentTicket.getName(),
                p3: 'has been updated'
              },
              success: true
            });
          }
          eventService.changedData({ changedData: aFCD });
        });
      }
    }
  };
};
